module.exports = __webpack_public_path__ + "img/inventory.9afa9e89.jpeg";